function adminRoutesResolver() {
    return [
        {
            meta: {
                title: 'Globalny panel Administracyjny',
                description: 'Globalny panel Administracyjny'
            },
            path: '/',
            component: () => import('layouts/admin/MainLayout.vue'),
            children: [{ path: '', component: () => import('pages/Home/HomeSgp.vue') }],
        },
        {
            meta: {
                title: 'ECCLEP - parafie',
                description: 'Parafie'
            },
            path: '/parafie',
            component: () => import('layouts/admin/MainLayout.vue'),
            children: [{ path: '', component: () => import('pages/Parishes/Parishes.vue') }],
        },
        {
            meta: {
                title: 'Logowanie',
                description: 'Logowanie'
            },
            path: '/login',
            component: () => import('pages/Account/LoginSgp.vue')
        },
        {
            meta: {
                title: 'Błąd 403',
                description: 'Dostęp zabroniony'
            },
            path: '/forbidden',
            component: () => import('pages/Error403Reg.vue'),
        },
        {
            meta: {
                title: 'Błąd 404',
                description: 'Nie istniejąca strona'
            },
            path: '/:catchAll(.*)*',
            component: () => import('pages/Error404.vue'),
        },
    ];
}
export default adminRoutesResolver;
